<script>
import { mapActions } from 'vuex';
import LocalizationButton from '@/components/LocalizationButton.vue';

export default {
  components: {
    LocalizationButton
  },
  computed: {
    locale() {
      return this.$i18n.locale.toUpperCase();
    }
  },
  methods: {
    ...mapActions(['setWidgetOpen'])
  }
};
</script>

<template>
  <section class="sticky top-0 bg-secondary form-controls">
    <div class="container flex justify-between opacity-80">
      <localization-button />
      <button @click="setWidgetOpen(false)" class="x-button m-0 cursor-pointer p-1.5 rounded transition-ease-out">
        <app-icon type="svg" name="exit" height="12" width="12" class="text-primary-text fill-current" />
      </button>
    </div>
  </section>
</template>
